export const JUMP_ADD = 'JUMP_ADD';
export const JUMP_REMOVE = 'JUMP_REMOVE';
export const JUMP_ADD_OPTION = 'JUMP_ADD_OPTION';
export const JUMP_REMOVE_OPTION = 'JUMP_REMOVE_OPTION';
export const JUMP_SET_ACTIVE = 'JUMP_SET_ACTIVE';
export const JUMP_CLEAR = 'JUMP_CLEAR';
export const JUMP_UPDATE_OPTION_ID = 'JUMP_UPDATE_OPTION_ID';
export const JUMP_UPDATE_DESTINATION_STEP_ID = 'JUMP_UPDATE_DESTINATION_STEP_ID';
export const JUMP_RESET_ACTIVE = 'JUMP_RESET_ACTIVE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/jump/types.js
 **/